import axios, { config } from '..';
import {
  UPDATE_PROVIDER_SUCCESS,
  UPDATE_PROVIDER_FAILED,
} from '../../actionTypes';

export default (body) => async (dispatch) => {
  try {
    let response;
    if (body) {
      response = await axios.put('/providers/update-profile', body, config);
    }

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: UPDATE_PROVIDER_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: UPDATE_PROVIDER_FAILED, error });
  }
};
